export default __webpack_public_path__ + "9659db92dbc9c899169660fa07a18838.svg";